import { render, staticRenderFns } from "./FstCollapseItem.vue?vue&type=template&id=30bbea1a&scoped=true"
import script from "./FstCollapseItem.vue?vue&type=script&lang=js"
export * from "./FstCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./FstCollapseItem.vue?vue&type=style&index=0&id=30bbea1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbea1a",
  null
  
)

export default component.exports